function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import hasInterface from '../../../../hasInterface';
import StringUtil from '../util/StringUtil';
import Double from '../../../../java/lang/Double';
import CoordinateSequence from './CoordinateSequence';
import StringBuilder from '../../../../java/lang/StringBuilder';
var CoordinateSequences = /*#__PURE__*/function () {
  function CoordinateSequences() {
    _classCallCheck(this, CoordinateSequences);
    CoordinateSequences.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateSequences, [{
    key: "getClass",
    value: function getClass() {
      return CoordinateSequences;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "copyCoord",
    value: function copyCoord(src, srcPos, dest, destPos) {
      var minDim = Math.min(src.getDimension(), dest.getDimension());
      for (var dim = 0; dim < minDim; dim++) {
        dest.setOrdinate(destPos, dim, src.getOrdinate(srcPos, dim));
      }
    }
  }, {
    key: "isRing",
    value: function isRing(seq) {
      var n = seq.size();
      if (n === 0) return true;
      if (n <= 3) return false;
      return seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n - 1, CoordinateSequence.Y);
    }
  }, {
    key: "isEqual",
    value: function isEqual(cs1, cs2) {
      var cs1Size = cs1.size();
      var cs2Size = cs2.size();
      if (cs1Size !== cs2Size) return false;
      var dim = Math.min(cs1.getDimension(), cs2.getDimension());
      for (var i = 0; i < cs1Size; i++) {
        for (var d = 0; d < dim; d++) {
          var v1 = cs1.getOrdinate(i, d);
          var v2 = cs2.getOrdinate(i, d);
          if (cs1.getOrdinate(i, d) === cs2.getOrdinate(i, d)) continue;
          if (Double.isNaN(v1) && Double.isNaN(v2)) continue;
          return false;
        }
      }
      return true;
    }
  }, {
    key: "extend",
    value: function extend(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);
      if (n > 0) {
        for (var i = n; i < size; i++) CoordinateSequences.copy(seq, n - 1, newseq, i, 1);
      }
      return newseq;
    }
  }, {
    key: "reverse",
    value: function reverse(seq) {
      var last = seq.size() - 1;
      var mid = Math.trunc(last / 2);
      for (var i = 0; i <= mid; i++) {
        CoordinateSequences.swap(seq, i, last - i);
      }
    }
  }, {
    key: "swap",
    value: function swap(seq, i, j) {
      if (i === j) return null;
      for (var dim = 0; dim < seq.getDimension(); dim++) {
        var tmp = seq.getOrdinate(i, dim);
        seq.setOrdinate(i, dim, seq.getOrdinate(j, dim));
        seq.setOrdinate(j, dim, tmp);
      }
    }
  }, {
    key: "copy",
    value: function copy(src, srcPos, dest, destPos, length) {
      for (var i = 0; i < length; i++) {
        CoordinateSequences.copyCoord(src, srcPos + i, dest, destPos + i);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      if (arguments.length === 1 && hasInterface(arguments[0], CoordinateSequence)) {
        var cs = arguments[0];
        var size = cs.size();
        if (size === 0) return '()';
        var dim = cs.getDimension();
        var builder = new StringBuilder();
        builder.append('(');
        for (var i = 0; i < size; i++) {
          if (i > 0) builder.append(' ');
          for (var d = 0; d < dim; d++) {
            if (d > 0) builder.append(',');
            builder.append(StringUtil.toString(cs.getOrdinate(i, d)));
          }
        }
        builder.append(')');
        return builder.toString();
      }
    }
  }, {
    key: "ensureValidRing",
    value: function ensureValidRing(fact, seq) {
      var n = seq.size();
      if (n === 0) return seq;
      if (n <= 3) return CoordinateSequences.createClosedRing(fact, seq, 4);
      var isClosed = seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n - 1, CoordinateSequence.Y);
      if (isClosed) return seq;
      return CoordinateSequences.createClosedRing(fact, seq, n + 1);
    }
  }, {
    key: "createClosedRing",
    value: function createClosedRing(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);
      for (var i = n; i < size; i++) CoordinateSequences.copy(seq, 0, newseq, i, 1);
      return newseq;
    }
  }]);
}();
export { CoordinateSequences as default };
CoordinateSequences.constructor_ = function () {};